<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-information-variant"
    fill-dot
  >
    <v-row
      no-gutters
      align="center"
      class="pr-12 mb-2 mt-n2 d-flex justify-center"
      :class="{ 'flex-column': $vuetify.display.smAndDown }"
    >
      <v-col md="8">
        <div class="text-subtitle-1">
          {{ leadStatus[data.status] ? $t(leadStatus[data.status]) : data.status }}
        </div>
        <div class="text-grey text--small">{{ $t('labels.by') }} {{ data.userName }}</div>
      </v-col>
      <v-col
        class="text-right text-grey text--small pr-8"
        :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
        md="4"
      >
        {{ formatDate(data.createdAt) }}
      </v-col>
    </v-row>
  </v-timeline-item>
</template>

<script>
import leadStatus from '@/lib/leadStatus'

export default {
  props: {
    data: { type: Object, default: null },
  },
  beforeCreate() {
    this.leadStatus = leadStatus
  },
}
</script>

<style scoped>
.text--small {
  font-size: 15px;
}
</style>
